import useValidate from '@/shared/lib/validate'
import { type Ref, ref, watchEffect } from 'vue'
import type { InventTab } from '@/entities/Manuals/Tabs'
import { useLoadTab } from '@/entities/Manuals/Tabs'
import { cloneDeep } from 'lodash'

export const useModel = () => {
  const { required } = useValidate()

  const fields: InventTab = {
    id: 0,
    alias: '',
    name: '',
    icon: '',
    sort: 10,
    is_show: true,
    is_mobile: false,
    params: {},
  }

  let data = ref({ ...fields })

  /* Правила валидации */
  const rules = {
    alias: [(value: string) => required(value)],
    name: [(value: string) => required(value)],
    icon: [(value: string) => required(value)],
  }

  /**
   * Функция приведения к дефолтным значениям
   */
  const clearData = () => {
    Object.keys(data).forEach((key) => {
      data[key] = fields[key]
    })
  }

  /**
   * Функция загрузки данных
   * @param tabId
   */
  const loadData = (tabId: Ref<string>) => {
    const result = useLoadTab(tabId)

    watchEffect(() => {
      if (result.data.value) {
        data.value = cloneDeep(result.data.value.data)
      }
    })

    return result
  }

  return {
    data,
    rules,

    clearData,
    loadData,
  }
}
